import { Action } from 'redux';

import { RunExtractRefresh } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';

export interface RunExtractRefreshAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function runExtractRefresh(tasks: IExtractTaskInfo[]): RunExtractRefreshAction {
  return {
    type: RunExtractRefresh,
    tasks
  };
}
